import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-2, message, chat" maskId="round-filled-radius-1-stroke-1.5-IconBubble2"><path d="M20.252 3C21.2185 3 22.002 3.7835 22.002 4.75V17.25C22.002 18.2165 21.2185 19 20.252 19H12.1946L7.36339 21.6572C7.13105 21.785 6.84849 21.7806 6.62023 21.6456C6.39198 21.5106 6.25195 21.2652 6.25195 21V19H3.75195C2.78546 19 2.00195 18.2165 2.00195 17.25V4.75C2.00195 3.7835 2.78546 3 3.75195 3H20.252Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble2;
